module.exports = __webpack_public_path__ + "frontend/img/icon-result-lt-5k.e2149271.svg";